// 木片勧進 主役12古材（knowledge/taizanso-takeshiro/content-hooks.md 由来）
// 座標は建物所在地の概略値（演出用）。年代は柱の高さ=古さの可視化に使う目安。

export interface KanjinSite {
  no: number
  piece: string      // 古材名
  building: string   // 出所の建造物
  kind: 'shrine' | 'temple' | 'other'
  lat: number
  lon: number
  year: number       // 目安年（古いほど御柱が高い）
  era: string
  note: string       // 一言来歴
}

export const SITES: KanjinSite[] = [
  { no: 42, piece: '擬宝珠の床柱', building: '久能寺（鉄舟寺）', kind: 'temple', lat: 35.028, lon: 138.467, year: 1200, era: '鎌倉（伝）', note: '橋の欄干の擬宝珠を、あえて逆さに吊った' },
  { no: 3, piece: '雲竜の天井', building: '熊野本宮大社', kind: 'shrine', lat: 33.840, lon: 135.774, year: 1590, era: '桃山', note: '金の双眸の竜が書斎を見下ろす' },
  { no: 16, piece: '白鳳の水城材', building: '太宰府・水城', kind: 'other', lat: 33.512, lon: 130.478, year: 664, era: '白鳳', note: '地中から掘り出された最古の木' },
  { no: 60, piece: '金箔の羽目板', building: '鵜戸神宮', kind: 'shrine', lat: 31.649, lon: 131.466, year: 1560, era: '戦国', note: '裏に往年の金箔が眠る' },
  { no: 53, piece: '朱漆の南扉', building: '三嶋大社', kind: 'shrine', lat: 35.122, lon: 138.919, year: 1690, era: '元禄', note: '三重塔の観音開き、朱漆が残る' },
  { no: 74, piece: '五老松の板', building: '大徳寺', kind: 'temple', lat: 35.044, lon: 135.746, year: 1650, era: '江戸', note: '裏面に来歴の墨書が現存' },
  { no: 38, piece: '御垢附の額縁板', building: '吉水神社（吉水院）', kind: 'shrine', lat: 34.364, lon: 135.859, year: 1336, era: '南北朝', note: '後醍醐天皇の踏んだ板' },
  { no: 54, piece: 'ビャクシンの鴨居', building: '大瀬神社', kind: 'shrine', lat: 35.024, lon: 138.789, year: 526, era: '樹齢一千五百年', note: '波のように浸食された御神木' },
  { no: 34, piece: '舞殿の木鼻', building: '鶴岡八幡宮', kind: 'shrine', lat: 35.326, lon: 139.556, year: 1191, era: '鎌倉', note: '静御前の舞の記憶・牡丹の彫刻' },
  { no: 85, piece: '法隆寺の棚板', building: '法隆寺', kind: 'temple', lat: 34.614, lon: 135.734, year: 607, era: '飛鳥', note: '日本最古の木造建築の記憶' },
  { no: 4, piece: '大鳥居の書棚戸', building: '厳島神社', kind: 'shrine', lat: 34.296, lon: 132.320, year: 1168, era: '平安', note: '平清盛の大鳥居の楠' },
  { no: 84, piece: '弁慶楠の板', building: '熊野速玉大社', kind: 'shrine', lat: 33.732, lon: 135.984, year: 1180, era: '伝承', note: '武四郎自身も「あられぬこと」と笑った' },
]

export const MITAKA = { lat: 35.688, lon: 139.523 }

/** 緯度経度→ワールドXZ（中心=137E/38N、1度≈7.4/9.0ユニット） */
export function toXZ(lat: number, lon: number): { x: number; z: number } {
  return { x: (lon - 137.0) * 7.4, z: -(lat - 38.0) * 9.0 }
}

export const MITAKA_XZ = toXZ(MITAKA.lat, MITAKA.lon)

export const OLDEST_YEAR = Math.min(...SITES.map((s) => s.year))
